const SETUSER = "SETUSER" as const;
const SETSHOP = "SETSHOP" as const;
const SETCOMPANY = "SETCOMPANY" as const;
const SETHEADQUARTER = "SETHEADQUARTER" as const;
const CLEAR = "CLEAR" as const;
const CURRENTSTATE = "CURRENTSTATE" as const;

export const set_user = (diff: any) => ({
  type: SETUSER,
  payload: diff,
});
export const set_headquarter = (diff: any) => ({
  type: SETHEADQUARTER,
  payload: diff,
});
export const set_company = (diff: any) => ({
  type: SETCOMPANY,
  payload: diff,
});
export const set_shop = (diff: any) => ({
  type: SETSHOP,
  payload: diff,
});
export const setClear = () => ({
  type: CLEAR,
});

export const setCurrentState = (diff: any) => ({
  type: CURRENTSTATE,
  payload: diff,
});

type AuthAction =
  | ReturnType<typeof set_user>
  | ReturnType<typeof set_shop>
  | ReturnType<typeof set_company>
  | ReturnType<typeof set_headquarter>
  | ReturnType<typeof setClear>
  | ReturnType<typeof setCurrentState>;

export interface User {
  isAgreed: boolean;
  USER_ID: string;
  NAME: string;
  PHONE_NUMBER: string;
  SHOP_ID: string;
  USER_TYPE: string;
  COMPANY_ID: string;
  USER_AUTH?: string;
}
export interface Shop {
  COMPANY_ID: string;
  SHOP_ID: string;
  NAME: string;
  OWNER_NAME: string;
  ADDRESS: string;
  ADDRESS_DETAIL: string;
  ZIPCODE: string;
  PLUG_IN_NB?: number;
  PLUG_IN_MA?: number;
  PLUG_IN_DP?: number;
  CONTRACT_DATE: string;
  SHOP_AUTH?: string;
  SHOP_STATUS?: number;
  x?: string;
  y?: string;
}

export interface Company {
  COMPANY_ID: string;
  NAME: string;
  OWNER_NAME: string;
  ADDRESS: string;
  ADDRESS_DETAIL: string;
  ZIPCODE: string;
  BRAND_NUMBER_URI: string;
  PLUG_IN_NB?: number;
  PLUG_IN_MA?: number;
  PLUG_IN_DP?: number;
  COMPANY_AUTH?: string;
  COMPANY_STATUS?: number;
  shopObjs: Shop[];
}

export interface Headquarter {
  NAME: string;
  HEADQUARTER_AUTH: string;
  companyObjs: Company[];
}

type CurrentState = {
  lastViewShop: string;
  lastViewCompany: string;
};

type AuthState = {
  user: User;
  shop: Shop;
  company: Company;
  headquarter: Headquarter;
  curState: CurrentState;
};
const initialState: AuthState = {
  user: {
    USER_ID: "",
    NAME: "",
    PHONE_NUMBER: "",
    SHOP_ID: "",
    USER_TYPE: "",
    COMPANY_ID: "",
    isAgreed: false,
  },
  shop: {
    COMPANY_ID: "",
    SHOP_ID: "",
    NAME: "",
    OWNER_NAME: "",
    ADDRESS: "",
    ADDRESS_DETAIL: "",
    ZIPCODE: "",
    CONTRACT_DATE: "",
    SHOP_AUTH: "1",
  },
  company: {
    COMPANY_ID: "",
    NAME: "",
    OWNER_NAME: "",
    ADDRESS: "",
    ADDRESS_DETAIL: "",
    ZIPCODE: "",
    BRAND_NUMBER_URI: "",
    shopObjs: [],
    COMPANY_AUTH: "1",
  },
  headquarter: {
    NAME: "",
    companyObjs: [],
    HEADQUARTER_AUTH: "1",
  },
  curState: {
    lastViewShop: "",
    lastViewCompany: "",
  },
  // 본부 or 가맹 or ''
};

function auth(state: AuthState = initialState, action: AuthAction): AuthState {
  switch (action.type) {
    case SETUSER:
      return {
        ...state,
        user: action.payload,
      };
    case SETSHOP:
      return {
        ...state,
        shop: action.payload,
      };
    case SETCOMPANY:
      return {
        ...state,
        company: action.payload,
      };
    case SETHEADQUARTER:
      return {
        ...state,
        headquarter: action.payload,
      };
    case CURRENTSTATE:
      const curState = { ...action.payload };
      if (!curState.lastViewShop) {
        curState.lastViewShop = "";
      }
      if (!curState.lastViewCompany) {
        curState.lastViewCompany = state.curState.lastViewCompany;
      }
      return {
        ...state,
        curState,
      };
    case CLEAR:
      return {
        user: initialState.user,
        shop: initialState.shop,
        company: initialState.company,
        headquarter: initialState.headquarter,
        curState: initialState.curState,
      };

    default:
      return state;
  }
}

export default auth;
